import logoBlanc from '../../../images/logoBlanc-pdf.png'
import logoNoir from '../../../images/logoNoir-pdf.png'
import signatureBlanche from '../../../images/signature-nawal-blanche.png'
import signatureNoire from '../../../images/signature-nawal-noire.png'

/* Les deux images du bilan (logo, signature de Nawal), par variante : les
   memes pour le PDF (pdfBilan.js) et pour les apercus a l'ecran
   (ApercuBilan.js). */
export const IMAGES_BILAN = {
  noire: { logo: logoBlanc, signature: signatureBlanche },
  claire: { logo: logoNoir, signature: signatureNoire },
}
